/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';

var RubleSignIcon = createIcon({
  name: 'RubleSignIcon',
  height: 512,
  width: 384,
  svgPath: 'M239.36 320C324.48 320 384 260.542 384 175.071S324.48 32 239.36 32H76c-6.627 0-12 5.373-12 12v206.632H12c-6.627 0-12 5.373-12 12V308c0 6.627 5.373 12 12 12h52v32H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v52c0 6.627 5.373 12 12 12h58.56c6.627 0 12-5.373 12-12v-52H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H146.56v-32h92.8zm-92.8-219.252h78.72c46.72 0 74.88 29.11 74.88 74.323 0 45.832-28.16 75.561-76.16 75.561h-77.44V100.748z',
  yOffset: '',
  xOffset: '',
  transform: ''
});

export default RubleSignIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-icons/dist/esm/icons/ruble-sign-icon.js
// module id = 891
// module chunks = 0